import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Avatar, Box, Paper, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Profile } from '@tassomutuo-backoffice/types';
import composeImageUri from '../../../../utils/composeImageUri';
import ProfileTableRenderCellAction from './ProfileTableRenderCellAction';
import { getProfiles } from '../../../../services/api/profile/profile';
import FilterEmailInput from './FilterEmailInput';

interface IProps {
  onEditRowClick: (row: Profile) => void;
}

const defaultPageModel = {
  page: 0,
  pageSize: 10,
};

const ProfilesTable = ({ onEditRowClick }: IProps) => {
  const [paginationModel, setPaginationModel] = useState(defaultPageModel);
  const [filterEmail, setFilterEmail] = useState('');

  const {
    isPending,
    data: profilesData,
    //error,
  } = useQuery({
    queryKey: ['Profiles', paginationModel, filterEmail],
    queryFn: () =>
      getProfiles({
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        email: filterEmail,
      }),
  });

  const [rowCountState, setRowCountState] = React.useState(
    profilesData?.totalResults || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      profilesData?.totalResults !== undefined
        ? profilesData?.totalResults
        : prevRowCountState
    );
  }, [profilesData?.totalResults, setRowCountState]);

  const onSubmitFilterEmail = (email: string) => {
    if (email) {
      setFilterEmail(email);
      setPaginationModel(defaultPageModel);
    } else {
      setFilterEmail('');
      setPaginationModel(defaultPageModel);
    }
  };

  const tableColumns: GridColDef<Profile>[] = [
    {
      field: 'profileImage',
      headerName: ' ',
      renderCell: ({ row }) => (
        <Avatar
          src={composeImageUri(row?.tassomutuoProfile?.profileImageUrl)}
        />
      ),
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'fullName',
      headerName: 'Nome',
      flex: 1,
      valueGetter: ({ row }) => `${row.name} ${row.lastName}`,
    },
    {
      field: 'provinces',
      headerName: 'Province',
      flex: 1,
      valueGetter: ({ row }) => row.tassomutuoProfile.provinces,
    },
    {
      headerName: ' ',
      field: ' ',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => (
        <ProfileTableRenderCellAction onEditClick={() => onEditRowClick(row)} />
      ),
      minWidth: 100,
    },
  ];

  return (
    <Box>
      <Typography variant="h5" mb={4}>
        Utenti con profilo TassoMutuo
      </Typography>
      <FilterEmailInput onSubmit={onSubmitFilterEmail} />

      <Paper>
        <DataGrid
          columns={tableColumns}
          rows={profilesData?.results || []}
          disableRowSelectionOnClick
          autoHeight
          rowCount={rowCountState}
          loading={isPending}
          pageSizeOptions={[10]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
      </Paper>
    </Box>
  );
};

export default ProfilesTable;
